<template>
  <MainHeader v-if="!flag"></MainHeader>
  <MainHeaderForDownload v-if="flag"></MainHeaderForDownload>
  <router-view class="main-layout"></router-view>
  <MainFooter v-if="!flag"></MainFooter>
  <MainFooterForDownload v-if="flag"></MainFooterForDownload>
</template>
<script lang="ts" setup>
import MainHeader from './MainHeader.vue'
import MainFooter from './MainFooter.vue';
import MainFooterForDownload from './MainFooterForDownload.vue'
import MainHeaderForDownload from './MainHeaderForDownload.vue';
// using es modules
import device from "current-device";
import { watchEffect } from 'vue';
const isMobile = device.mobile()
const route = useRoute()
const isDownload = ref(false)
const flag = ref(false)
watchEffect(() => {
  console.log(route.path)
  isDownload.value = (route.path == '/download' || route.path == '/iprt_download')
  console.log("是否是下载页面", isDownload.value)
  flag.value = isMobile && isDownload.value
  console.log("----------------flag:", flag.value)
})

</script>
<style>
.main-layout {
  margin-top: 78px;
  background-color: #fbfbfb;
  padding-bottom: 20px;
}
</style>